import Cookies from 'universal-cookie';
import config from '../config';
import en from '../assets/images/countryFlags/UK.svg';
import pt from '../assets/images/countryFlags/BR.svg';
import es from '../assets/images/countryFlags/ES.svg';
import { errorCodes } from './error-codes';

const navigatorLang = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
export const defaultLang = 'en';

export const setCookieLanguage = lang => {
  if (languages.filter(l => l.value === lang).length > 0) {
    const cookies = new Cookies();
    cookies.set('lang', lang, { path: '/' });
  }
};

export const getLanguage = () => {
  const cookies = new Cookies();
  const l = cookies.get('lang');

  if (l) {
    // return cookie lang
    return l.toLowerCase();
  }

  const navLang = navigatorLang ? navigatorLang.match(/.{0,2}/g)[0] : null;
  if (navLang && languages.filter(l => l.value === navLang).length > 0) {
    setCookieLanguage(navLang);
    // return navigator lang
    return navLang;
  }

  setCookieLanguage(defaultLang);
  // return default lang
  return defaultLang;
};

export const realoadPage = () => {
  window.location.reload();
};

export const openNewTabAndFocus = url => {
  window.open(url);
  window.focus();
};

export const openUrl = url => {
  window.open(url);
};

export const redirecTo = url => {
  window.location.href = url;
};

export const languages = [
  {
    value: 'en',
    src: en,
  },
  {
    value: 'pt',
    src: pt,
  },
  {
    value: 'es',
    src: es,
  },
];

export const isRefreshTokenNecessary = stateAuth => {
  try {
    if (stateAuth && stateAuth.token && stateAuth.token !== '') {
      if (stateAuth.tokenExpiration) {
        const dateExp = new Date(stateAuth.tokenExpiration);
        const dateNow = new Date();
        const diff = dateExp - dateNow;
        return config.refreshToken > diff;
      }
    }
  } catch (ex) {
    return true;
  }
  return true;
};

export const isTabletMobile = () => {
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  return vw < 1024;
};

export const handleErrorInfo = (key, error) => {
  const errorMessages = errorCodes(error.appState);
  let err = null;
  try {
    if (error) {
      const { body = {}, status } = error;
      const { errorCode, errorFields } = body;
      err = errorMessages[key]
        ? (errorMessages[key][status] && errorMessages[key][status][errorCode]) ||
        (errorMessages[key][status] && errorMessages[key][status].default) ||
        errorMessages[key][errorCode] ||
        (errorMessages[key][errorCode] && errorMessages[key][errorCode].default) ||
        (errorMessages[key] && errorMessages[key].default) ||
        null
        : null;
      if (err && errorFields) {
        return { ...err, errorFields };
      }
    }
    return err;
  } catch (ex) {
    return err;
  }
};

export const createDate = date => {
  return new Date(`${date}Z`);
};

export const countryToFlag = isoCode => {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
};

export const scrollIntoView = (ref, block = 'start', behavior = 'smooth') => {
  // block: start, center, end, or nearest.
  // behavior: auto or smooth.
  try {
    if (ref?.current) {
      ref.current.scrollIntoView({ block, behavior });
    }
  } catch (ex) {
    // Error
  }
};

export const removeProtocolFromUrl = url => {
  return url?.replace(/http(s)?:\/\//g, '') || url;
};

export const callbackUrlIsFromShopify = callbackUrl => {
  try {
    const url = new URL(callbackUrl);
    return url?.hostname === 'shop.dlocalgo.com';
  } catch (ex) {
    return false;
  }
};
